import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import TopLocationItem from './top-location-item';
import {
    DesktopTopLocationsContainer,
    ModernTopLocationsContainer,
    VotTopLocationsContainer,
} from './top-locations.style';

const TopLocations = ({
    items,
    showTitle,
    modern = false,
    showModernTitle = true,
    desktopRedesign = false,
    showDesktopTitle = true,
    vot = false,
    homepageSeo = false,
    ...props
}) => {
    if (vot) {
        return (
            <VotTopLocationsContainer className="vot-browse-links-content" {...props}>
                <div className="vot-top-locations-groups">
                    {items.map((location, index) => (
                        <TopLocationItem key={index} {...location} showTitle={false} />
                    ))}
                </div>
            </VotTopLocationsContainer>
        );
    }

    if (desktopRedesign) {
        const locations = items.flatMap((location) => location.items);
        const columnBreak = Math.ceil(locations.length / 5);
        const columns = Array.from({ length: 5 }, (_, index) => ({
            items: locations.slice(index * columnBreak, (index + 1) * columnBreak),
            positionOffset: index * columnBreak,
        }));

        return (
            <DesktopTopLocationsContainer {...props}>
                {showDesktopTitle && <h2>Top Locations</h2>}
                <div className="top-locations-columns">
                    {columns.map((column, index) => (
                        <TopLocationItem
                            key={index}
                            items={column.items}
                            positionOffset={column.positionOffset}
                            title=""
                            showTitle={false}
                            omitNativeTitle
                            homepageSeo={homepageSeo}
                        />
                    ))}
                </div>
            </DesktopTopLocationsContainer>
        );
    }

    if (modern) {
        const locations = items.flatMap((location) => location.items);
        const columnBreak = Math.ceil(locations.length / 2);
        const columns = [locations.slice(0, columnBreak), locations.slice(columnBreak)];

        return (
            <ModernTopLocationsContainer {...props}>
                {showModernTitle && <h2>Top Locations</h2>}
                <div className="top-locations-columns">
                    {columns.map((column, index) => (
                        <TopLocationItem
                            key={index}
                            items={column}
                            positionOffset={index * columnBreak}
                            title=""
                            showTitle={false}
                            homepageSeo={homepageSeo}
                        />
                    ))}
                </div>
            </ModernTopLocationsContainer>
        );
    }

    return (
        <Fragment>
            {items.map((location, index) => (
                <TopLocationItem key={index} {...location} showTitle={showTitle} />
            ))}
        </Fragment>
    );
};

TopLocations.propTypes = {
    items: PropTypes.array.isRequired,
    showTitle: PropTypes.bool.isRequired,
    modern: PropTypes.bool,
    showModernTitle: PropTypes.bool,
    desktopRedesign: PropTypes.bool,
    showDesktopTitle: PropTypes.bool,
    homepageSeo: PropTypes.bool,
    vot: PropTypes.bool,
};

export default TopLocations;
